import { appType, AppType } from "../../helper/appInfo.js";
import type { NexusHandler } from "@otto-ec/global-resources/nexus";
import type { NativeAppEventAndroidDTO } from "./nativeAppEventAndroidDTO.js";
import {type AppsGlobal, type NativeAppEvent} from "../index.js";

export const retrieveNativeAppEvents: NexusHandler<AppsGlobal["retrieveNativeAppEvents"]> = async () => {
    const fallbackValue: NativeAppEvent[] = []

    if(appType() == AppType.ANDROID) {
        const events = window.o_apps_android?.retrieveNativeAppEvents?.()
    
        if (!events) return fallbackValue

        /*                                                                 */
        const nativeAppEventAndroidDTO = JSON.parse(events) as NativeAppEventAndroidDTO[]

        return nativeAppEventAndroidDTO.map((event) => ({
            ...event,
            timestamp: new Date(event.timestamp)
        }));
    
    } else if(appType() == AppType.IOS) {
        return window.webkit?.messageHandlers?.retrieveNativeAppEvents?.postMessage({}) ?? fallbackValue
    }
    return fallbackValue;
}